import { render, staticRenderFns } from "./blogin.vue?vue&type=template&id=683f2dc5&scoped=true&"
import script from "./blogin.vue?vue&type=script&lang=js&"
export * from "./blogin.vue?vue&type=script&lang=js&"
import style0 from "./blogin.vue?vue&type=style&index=0&id=683f2dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f2dc5",
  null
  
)

export default component.exports